import { ChartDataSeries, POSTActionClockInBody, PUTActionClockOutBody, PUTAutomatedBreakSettingsBody, ReportData } from './index'
import { IPaginatedRequest, IProductivityReportRequest } from '../../request'
import { HttpMethod } from '@cbgms/api'

export const listClockingActions = (params: IPaginatedRequest) => ({
  method: 'GET',
  url: `/modules/clocking-actions`,
  params
})

export const currentClockingAction = () => ({
  method: HttpMethod.GET,
  url: `/modules/clocking-actions/current`
})

export const clockInAction = (body: POSTActionClockInBody) => ({
  method: 'POST',
  url: '/modules/clocking-actions/in',
  data: body
})

export const clockOutAction = (body: PUTActionClockOutBody) => ({
  method: 'PUT',
  url: `/modules/clocking-actions/out`,
  data: body
})

export const workorderClockingActions = (workorderUUID: string) => ({
  method: HttpMethod.GET,
  url: `/modules/clocking-actions/by-workorder/${workorderUUID}`
})

export const employeeClockingActions = (params: IPaginatedRequest) => ({
  method: 'GET',
  url: '/modules/clocking-actions/employees',
  params
})

export const getClockingYearList = () => ({
  method: 'GET',
  url: `/modules/clocking-actions/years`
})

export const getProductivityReport = (params: IProductivityReportRequest) => ({
  method: 'GET',
  url: '/modules/reporting/report/time-registration-v2/productivity',
  params
})

export const getAutomatedBreakSettings = () => ({
  method: 'GET',
  url: '/modules/clocking-actions/automated-break-settings'
})

export const updateAutomatedBreakSetting = (data: PUTAutomatedBreakSettingsBody) => ({
  method: 'PUT',
  url: '/modules/clocking-actions/automated-break-settings',
  data
})

export const isReportDataArray = (data: ChartDataSeries[]): data is ReportData[] => {
  return data.every(item => 'Productivity' in item && item.Efficiency === undefined)
}
